"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectUserSettingLayoutTheme = exports.selectSettingsDataFetchItem = exports.selectSettingsDataProp = exports.selectSettingsData = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const slice_1 = require("./slice");
const selectSettingsData = (state) => state.settingsProvider.data.entry || slice_1.initialState.data.entry;
exports.selectSettingsData = selectSettingsData;
const selectSettingsDataProp = (state, propName) => { var _a; return (_a = state.settingsProvider.data.entry) === null || _a === void 0 ? void 0 : _a[propName]; };
exports.selectSettingsDataProp = selectSettingsDataProp;
const selectSettingsDataFetchItem = (state) => state.settingsProvider.data.fetchItem || slice_1.initialState.data.fetchItem;
exports.selectSettingsDataFetchItem = selectSettingsDataFetchItem;
const selectUserSettingLayoutTheme = (state) => {
    var _a, _b, _c;
    return !((_a = state.settingsProvider.data.entry) === null || _a === void 0 ? void 0 : _a.layoutTheme) ||
        ((_b = state.settingsProvider.data.entry) === null || _b === void 0 ? void 0 : _b.layoutTheme) === betweb_openapi_axios_1.LayoutTheme.Unknown // The theme should be light by default
        ? betweb_openapi_axios_1.LayoutTheme.Light
        : (_c = state.settingsProvider.data.entry) === null || _c === void 0 ? void 0 : _c.layoutTheme;
};
exports.selectUserSettingLayoutTheme = selectUserSettingLayoutTheme;
//# sourceMappingURL=selectors.js.map